import type { AppThunk } from "../";
import type { PageEnvelope } from "@skv/core";

import { OrganisationSearchResults } from "./reducer";
import { OrganisationSearchQueryState } from "../context/OrganisationSearchQuery";
import { organisationSearchQueryToString } from "./util";

export const fetchOrganisations = (
  searchQuery?: OrganisationSearchQueryState
): AppThunk<Promise<OrganisationSearchResults>> => async (
  dispatch,
  getState
): Promise<OrganisationSearchResults> => {
  const query = organisationSearchQueryToString(searchQuery);

  const currentState = getState();

  if (currentState.organisationResult.data[query]) {
    dispatch({
      type: "ORG_RESULT:FETCH:END",
      payload: {
        searchQuery: query,
        data: currentState.organisationResult.data[query],
      },
    });
    return currentState.organisationResult.data[query];
  }

  dispatch({
    type: "ORG_RESULT:FETCH:START",
  });

  return fetch(`/api/organisation/search?${query}`)
    .then<PageEnvelope<{ organisationResult: OrganisationSearchResults }>>(
      (res) => {
        if (res.ok) {
          return res.json();
        }
      }
    )
    .then(({ data, errorCode, errorMessage, success }) => {
      if (!success) {
        throw Error("Failed to get orgnanisations");
      }

      dispatch({
        type: "ORG_RESULT:FETCH:END",
        payload: {
          searchQuery: query,
          data: data.organisationResult,
        },
      });

      return data.organisationResult;
    });
};
